import React, { useState } from "react";
import { FaWhatsapp, FaTimes, FaPaperPlane } from "react-icons/fa";
import "./WhatsAppBot.css";

export default function WhatsAppBot() {

    const questions = [
        "שלום 👋 אני הסוכן הדיגיטלי של האתר\nהאם יש לך עסק ?",
        "איזה סוג אתר אתה מעוניין ?",
        "מה השם שלך ?",
        "מה מספר הטלפון שלך ?"
    ];

    const options = [
        [
            "כן, יש לי עסק",
            "לא, עדיין אין לי עסק"
        ],
        [
            "עמוד נחיתה",
            "אתר תדמית",
            "אתר מכירות",
            "לא כל כך יודע"
        ]
    ];

    const [open, setOpen] = useState(false);
    const [messages, setMessages] = useState([
        { type: "bot", text: questions[0] }
    ]);

    const [step, setStep] = useState(0);
    const [input, setInput] = useState("");
    const [answers, setAnswers] = useState([]);
    const [selectedOption, setSelectedOption] = useState(false);
    const [finished, setFinished] = useState(false);

    function selectOption(option) {

        setAnswers(prev => [...prev, option]);
        setSelectedOption(true);

        setMessages(prev => [
            ...prev,
            { type: "user", text: option }
        ]);

        if (step < questions.length - 1) {

            setTimeout(() => {

                const nextStep = step + 1;

                setMessages(prev => [
                    ...prev,
                    { type: "bot", text: questions[nextStep] }
                ]);

                setStep(prev => prev + 1);
                setSelectedOption(false);

            }, 500);
        }
    }
function sendMessage() {

    if (!input.trim()) return;

    if (options[step]) return;

    // שם
    if (step === 2) {

        const nameRegex = /^[א-תa-zA-Z\s]{2,}$/;

        if (!nameRegex.test(input.trim())) {

            setMessages(prev => [
                ...prev,
                {
                    type: "bot",
                    text: "❌ נא להזין שם תקין"
                }
            ]);

            return;
        }
    }

    // טלפון
    if (step === 3) {

        const cleanPhone = input.replace(/\D/g, "");

        if (!/^05\d{8}$/.test(cleanPhone)) {

            setMessages(prev => [
                ...prev,
                {
                    type: "bot",
                    text: "❌ נא להזין מספר טלפון תקין\nלדוגמה: 0501234567"
                }
            ]);

            return;
        }

        setAnswers(prev => [...prev, cleanPhone]);

        setMessages(prev => [
            ...prev,
            {
                type: "user",
                text: cleanPhone
            }
        ]);

        setInput("");

        setStep(questions.length);

        setTimeout(() => {

            setMessages(prev => [
                ...prev,
                {
                    type: "bot",
                    text: "🎉 מעולה!\nלחץ על הכפתור לשליחה לוואטסאפ"
                }
            ]);

            setFinished(true);

        }, 500);

        return;
    }

    setAnswers(prev => [...prev, input]);

    setMessages(prev => [
        ...prev,
        {
            type: "user",
            text: input
        }
    ]);

    setInput("");

    setTimeout(() => {

        const nextStep = step + 1;

        setMessages(prev => [
            ...prev,
            {
                type: "bot",
                text: questions[nextStep]
            }
        ]);

        setStep(nextStep);

    }, 500);
}
function sendWhatsapp() {

    const text = `
לקוח חדש מהאתר 🖥️

האם יש עסק:
${answers[0]}

סוג אתר:
${answers[1]}

שם:
${answers[2]}

טלפון:
${answers[3]}
`;

    window.open(
        `https://api.whatsapp.com/send?phone=972506831839&text=${encodeURIComponent(text)}`,
        "_blank"
    );

    setFinished(false);

    setMessages(prev => [
        ...prev,
        {
            type: "bot",
        text:"✅ תודה רבה !\nקיבלנו את הפרטים.\   נחזור אליך בהקדם."
        }
    ]);
setTimeout(() => {
    setStep(0);
    setAnswers([]);
    setInput("");

    setMessages([
        {
            type: "bot",
            text: questions[0]
        }
    ]);
}, 30000); // אחרי 30 שניות
}
    return (
        <>
            <button className="wa-button" onClick={() => setOpen(true)}>
                <FaWhatsapp />
            </button>

            {open && (
                <div className="chat">

                    <div className="header">
                        <div className="logoArea">
                            <img src="/logo1922.png" alt="Siteb2b" />
                            <span>Siteb2b</span>
                        </div>

                        <button onClick={() => setOpen(false)}>
                            <FaTimes />
                        </button>
                    </div>

                    <div className="messages">

                        {messages.map((msg, i) => (
                            <div
                                key={i}
                                className={msg.type === "bot" ? "bot" : "user"}
                            >
                                {msg.text}
                            </div>
                        ))}

                        {options[step] && !selectedOption && (
                            <div className="options">
                                {options[step].map((item, i) => (
                                    <button
                                        key={i}
                                        onClick={() => selectOption(item)}
                                    >
                                        ◯ {item}
                                    </button>
                                ))}
                            </div>
                        )}

                    </div>

                    {/* INPUT רק בשאלות פתוחות */}
                    {!options[step] && (
                        <div className="inputBox">

                            <input
                                value={input}
                                onChange={e => setInput(e.target.value)}
                                onKeyDown={e => {
                                    if (e.key === "Enter") sendMessage();
                                }}
                                placeholder="כתוב הודעה..."
                            />

                            <button onClick={sendMessage}>
                                <FaPaperPlane />
                            </button>

                        </div>
                    )}

                    {/* כפתור וואטסאפ רק בסוף */}
                    {finished && (
                        <button className="sendWA" onClick={sendWhatsapp}>
                            שליחה לוואטסאפ 🟢
                        </button>
                    )}

                </div>
            )}
        </>
    );
}